'use strict'
// 根据环境引入不同配置 process.env.ENV_CONFIG  ex:dev.conf.js
// console.log('process.env.ENV_CONFIG', process.env.ENV_CONFIG)
const config = require('./' + process.env.ENV_CONFIG + '.conf')
module.exports = config



// WEBPACK FOOTER //
// ./src/config/index.js